import './index.scss'

const Logo = () => {
  return (
    <div className="logo-container">
      <svg viewBox="0 0 190 240" xmlns="http://www.w3.org/2000/svg">
        <text className="solid-logo" x="50%" y="52%">
          B
        </text>
        <text className="svg-container" x="50%" y="52%">
          B
        </text>
      </svg>
    </div>
  )
}

export default Logo
